import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    padding: 7em 0 0;

    .title-wrapper{
        margin-top: 2.6em;

        h1.title {
            line-height: 1.15em;
            padding: .15em;

            .underline-large {
                background-position-y: 93%;
            }
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        font-size: 90%;
        padding: 0;

        .title-wrapper{
            h1.title {
                line-height: 1em;

                .underline-large {
                    background-position-y: 90%;
                }
            }
        }
    }
`;